module.exports = __webpack_public_path__ + "img/oops.23e83ed2.jpg";